var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cover_url)?_c('b-card-img-lazy',{attrs:{"top":true,"src":_vm.cover_url,"alt":_vm.cover_alt,"srcset":_vm.cover_srcset_array,"sizes":"248px","blank-color":"#bbb","height":(_vm.cover_height / _vm.cover_width) * 248,"width":"248"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }